"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CardNotification = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Button = require("@fluentui/react/lib/Button");

var _Link = require("@fluentui/react/lib/Link");

var _Utilities = require("@fluentui/react/lib/Utilities");

var React = _interopRequireWildcard(require("react"));

var _singleLetterRelativeTime = require("../../dates/singleLetterRelativeTime");

var cardStyles = require('@microsoft/portal-app/lib/styling/patterns/Card.scoped.scss');

var cardNotificationStyles = require('./CardNotification.scoped.scss');
/**
 * Represets an Individual Notification in the form of a Card.
 */


var CardNotification = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CardNotification, _React$Component);

  var _super = (0, _createSuper2.default)(CardNotification);

  function CardNotification() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, CardNotification);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));

    _this._raisePrimaryAction = function () {
      _this.props.primaryAction && _this._raiseAction(_this.props.primaryAction);
    };

    _this._raiseSecondaryAction = function () {
      _this.props.secondaryAction && _this._raiseAction(_this.props.secondaryAction);
    };

    _this._raiseTertiaryAction = function () {
      _this.props.tertiaryAction && _this._raiseAction(_this.props.tertiaryAction);
    };

    _this._raiseAction = function (notificationAction) {
      var actionName = notificationAction && notificationAction.action;
      var payload = notificationAction && notificationAction.payload;

      _this.props.raiseAction(actionName, payload);
    };

    return _this;
  }

  (0, _createClass2.default)(CardNotification, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          localizableMessage = _this$props.localizableMessage,
          localizableTitle = _this$props.localizableTitle,
          createdDateTime = _this$props.createdDateTime,
          tertiaryAction = _this$props.tertiaryAction,
          primaryAction = _this$props.primaryAction,
          secondaryAction = _this$props.secondaryAction;
      var message = localizableMessage && this.props.t && this.props.t(localizableMessage.key, localizableMessage.options);
      var title = localizableTitle && this.props.t && this.props.t(localizableTitle.key, localizableTitle.options);
      var primaryActionIcon = primaryAction && primaryAction.iconProps;
      var secondaryActionIcon = secondaryAction && secondaryAction.iconProps;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _Utilities.css)(cardStyles.card, cardNotificationStyles.card),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _Utilities.css)(cardNotificationStyles.header),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _Utilities.css)(cardStyles.cardPrimaryContent, cardNotificationStyles.title, cardStyles.cardTitle),
            children: title
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _Utilities.css)(cardNotificationStyles.cardActionItemFar, cardNotificationStyles.timeAgo),
            children: (0, _singleLetterRelativeTime.getSingleLetterRelativeTime)(createdDateTime)
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _Utilities.css)(cardNotificationStyles.cardContent, cardNotificationStyles.cardMessage),
          children: message
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _Utilities.css)(cardNotificationStyles.cardContent, cardNotificationStyles.cardActionsRow),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _Utilities.css)(cardNotificationStyles.cardActionItem, cardNotificationStyles.hideOnHover),
            children: tertiaryAction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
              onClick: this._raiseTertiaryAction,
              children: this.props.t('View')
            }) : null
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: (0, _Utilities.css)(cardNotificationStyles.cardActionItemFar),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: (0, _Utilities.css)(cardNotificationStyles.cardActionItem),
              children: primaryAction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.IconButton, {
                onClick: this._raisePrimaryAction,
                className: (0, _Utilities.css)(cardNotificationStyles.acceptButton),
                iconProps: primaryActionIcon ? (0, _objectSpread2.default)({}, primaryActionIcon) : {
                  iconName: 'Completed',
                  title: 'Confirm',
                  ariaLabel: 'Confirm',
                  className: cardNotificationStyles.icon
                }
              }) : null
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: (0, _Utilities.css)(cardNotificationStyles.cardActionItem),
              children: secondaryAction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.IconButton, {
                onClick: this._raiseSecondaryAction,
                className: (0, _Utilities.css)(cardNotificationStyles.denyButton),
                iconProps: secondaryActionIcon ? (0, _objectSpread2.default)({}, secondaryActionIcon) : {
                  iconName: 'ErrorBadge',
                  title: 'Deny',
                  ariaLabel: 'Deny',
                  className: cardNotificationStyles.icon
                }
              }) : null
            })]
          })]
        })]
      });
    }
  }]);
  return CardNotification;
}(React.Component);

exports.CardNotification = CardNotification;